function b64toBlob(b64Data: string, contentType = '') {
  const binaryData = atob(b64Data);
  const bytes = Uint8Array.from(binaryData, (character) => character.charCodeAt(0));
  return new Blob([bytes], { type: contentType });
}

export function getPDFObjectURL(b64Data: string) {
  const blob = b64toBlob(b64Data, 'application/pdf');
  return URL.createObjectURL(blob);
}

export function base64ToPDFFile(base64: string, fileName: string) {
  const mimeType = 'application/pdf';
  const blob = b64toBlob(base64, mimeType);
  return new File([blob], fileName, { type: mimeType });
}
